// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2l_3eRXBU1a5oERhtBxpLi {\n  padding: 0;\n}\n\n._3mbTuEHYUv64ZGdJiLQtAN {\n  background: #ececec;\n  border: 1px solid #c7c7c7;\n  padding: 8px 12px;\n}\n\n._1udSipblTaoCwBufkVQBs5 {\n  font-size: 14px;\n  font-weight: 800;\n  margin: 5px 0 10px;\n}\n\n._2RMudhoKFQmSnuWZL7LHlK {\n  margin-bottom: 10px;\n}\n\n._13liCYVY2K3mvNYnyfJGRl {\n  font-weight: 600px;\n}", ""]);
// Exports
exports.locals = {
	"container": "_2l_3eRXBU1a5oERhtBxpLi",
	"disclaimer": "_3mbTuEHYUv64ZGdJiLQtAN",
	"addressHeading": "_1udSipblTaoCwBufkVQBs5",
	"address": "_2RMudhoKFQmSnuWZL7LHlK",
	"suggestedColumn": "_13liCYVY2K3mvNYnyfJGRl"
};
module.exports = exports;
